<template>
  <v-card class="pa-1" color="grey lighten-3">
    <div>
      <div>
        <small class="mt-2">
          ރިމާކްސް (ރިޖެކްޓް ކުރައްވާނަމަ ފުރިހަމަ ކުރުން މަޖްބޫރު)
        </small>
        <dhivehi-text-area v-model="form.remarks"></dhivehi-text-area>
      </div>
      <v-autocomplete
        v-if="action.options"
        dir="ltr"
        dense
        outlined
        :items="action.options"
        item-text="label"
        item-value="value"
        v-model="form.action"
        hide-details
        return-object
      ></v-autocomplete>

      <v-divider class="my-2"></v-divider>
      <v-btn
        x-small
        color="green"
        :disabled="
          !form.action ||
          (form.action.value == 'rejected' && (!form.remarks || form.remarks.length < 5))
        "
        @click="process()"
      >
        SAVE
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import DhivehiTextArea from '../util/DhivehiTextArea.vue'

export default {
  data: () => ({
    form: {
      action: null,
      remarks: null,
    },
    loading: false,
  }),
  components: { DhivehiTextArea },
  props: {
    action: {
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
    refID: {
      type: Number,
      required: true,
    },
    beforeProcess: {
      type: Function,
      required: false,
    },
  },
  methods: {
    async process() {
      //         'action' => [
      // *          'step_id' => 1,
      // *          'method' => leaveApproval'
      // *          'decision' => [
      // *              'value' => 'accept',
      // *              'nextStatus' => 'substitute2_approval'
      // *          ],
      // *          'remarks' => 'no pending works',
      // *          'matched_section_id' => null,
      // *          'matched_unit_id' => null
      // *      ]
      if (this.beforeProcess) await this.beforeProcess()
      this.action.decision = this.form.action
      this.action.remarks = this.form.remarks
      this.$axios
        .post(`/api/approval_stages/applyAction/${this.model}/${this.refID}`, {
          action: this.action,
        })
        .then(() => {
          this.$emit('processed', true)
          Object.assign(this.$data.form, this.$options.data().form)
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
